import { useRecoilValue } from 'recoil';
import {
    SaveDICOMToCacheRequestBody,
    useSaveDICOMToCache,
} from '~/backend/connector-api/connector-components';
import { environmentState } from '~/state/atoms/engineAtoms';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';
import { handleError } from '~/utils/errors';

/**
 * Handles uploading of structure set for cache update.
 * @returns {Function} - A start function to initiate cache update for current structure set.
 */
export default function useStructureSetCacheUpdate() {
    const currentStructureSet = useRecoilValue(currentStructureSetState);
    const environment = useRecoilValue(environmentState);
    const { mutateAsync: saveDICOMToCache } = useSaveDICOMToCache();

    const update = async () => {
        try {
            if (environment && currentStructureSet) {
                environment.saveChanges();
                const structureSetBlob = currentStructureSet.export();
                const formData = new FormData();
                formData.append(
                    'files',
                    structureSetBlob,
                    `RS_${currentStructureSet.structureSetLabel}.dcm`
                );
                await saveDICOMToCache({
                    body: formData as unknown as SaveDICOMToCacheRequestBody,
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
            }
        } catch (error) {
            handleError(
                error,
                'Failed to update cached file for structure set.'
            );
        }
    };

    return update;
}
